import React from 'react';
import Container from './container';
import { Helmet } from 'react-helmet';
import { withPrefix } from "gatsby";
import Cookies from 'js-cookie'

class Template extends React.Component {
     constructor(props) {
          super(props);
          const loginCookies = Cookies.get('loginPetinsuDev');
          this.state = { isLogin: process.env.GATSBY_DOMAIN.indexOf('petinsu-dev') > -1 && typeof loginCookies === 'undefined' ? false : true };
     }

     checkLogin = () => {
          if (typeof window !== 'undefined') {
               const login = window.prompt('Please enter password');
               if (login === 'pet#') {
                    this.setState({ isLogin: true });
                    Cookies.set('loginPetinsuDev', true, { expires: 7 });
               } else {
                    this.checkLogin();
               }
          }
     }

     componentDidMount() {
          if (!this.state.isLogin) {
               this.checkLogin();
          }
     }

     render() {
          const { children } = this.props

          let rootPath = `/`
          if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
               rootPath = __PATH_PREFIX__ + `/`
          }

          return (
               this.state.isLogin && (
                    <Container>
                         <a className="nw-header__skip" href="#main-content">Skip to main content</a>
                         {children}
                         <Helmet>
                              <script src={withPrefix('js/common.js')} type="text/javascript" />
                         </Helmet>
                    </Container>
               )
          )
     }
}

export default Template
